import { Cart } from '../types';
import { cartRequest } from './request';

export type CartItemChanges = {
  quantity?: number;
  /**
   * Whether this line is a gift.
   *
   * Sent only when the caller names it: `UpdateCartItemType` reads the key's *presence*
   * rather than its value, so omitting it leaves the flag as it was, and sending
   * `undefined` would be a change to false.
   *
   * Prefer this over the legacy `xCmd=toggle-gift`, which flips whatever is there. A
   * toggle double-fired by an impatient click lands back where it started; setting a
   * value cannot.
   */
  sendAsGift?: boolean;
};

/**
 * Changes one line of the cart and answers the cart it produced.
 *
 * `itemId` is the line's id, not the product's.
 */
export default async function updateItem(itemId: number, changes: CartItemChanges): Promise<Cart> {
  const body: Record<string, unknown> = {};

  if (changes.quantity !== undefined) {
    body.quantity = changes.quantity;
  }

  if (changes.sendAsGift !== undefined) {
    body.send_as_gift = changes.sendAsGift;
  }

  return cartRequest(`/services_api/storefront/v1/cart/items/${itemId}.json`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}
